/*
  FORCE · Fondo vivo A3 + cajas A en TODO el sitio (Design System FORCE, estándar del 1-nov-2026) · v2, 3-nov-2026
  v1 (3-nov, ranking): port fiel de odraw(t, dt, 3) de «Explorando nuevos diseños» (ES-08, ES-10 a ES-15)
  v2 (3-nov, sitio completo): el <canvas class="fa3-bg"> vive en layout/theme.liquid, así que este script corre en todas
  las páginas. Lo nuevo:
  - Portada: el fondo parte DESPUÉS del video del héroe (.f-hero): el lienzo está apagado arriba y se enciende a medida
    que el héroe sale de pantalla (opacidad ligada al scroll). Sin héroe, el fondo se ve desde el primer píxel.
  - Cajas A del sitio por selector (la misma lista vive en force-ds-site.css, generadas las dos desde src/build.py):
    las que se inclinan (tarjetas en filas) y las que se quedan quietas (formularios, mapas, texto largo, ventanas).
  - `data-fa3-planet="0"` en cualquier elemento de la página: fondo negro sin planeta, anillo ni arcos (las cajas siguen).
  - Si por error hay dos lienzos (una sección vieja que todavía lo pone), se queda solo el primero.
  Comportamiento de caja: luz dorada del borde que sigue al cursor, sombra opuesta, línea que recorre el borde desde el
  punto de entrada (ES-16) y fondo en calma (ES-14). Caja con campos: fija al tocarla o con el foco (ES-18).
  Secundario de vidrio (ES-05): luz dorada del borde. Con movimiento reducido el planeta queda fijo; sin cursor, nada se inclina.
*/
(function () {
  'use strict';
  var all = document.querySelectorAll('.fa3-bg');
  if (!all.length) return;
  for (var k = 1; k < all.length; k++) all[k].parentNode.removeChild(all[k]);
  var cv = all[0];
  if (!cv.getContext) return;
  var ctx = cv.getContext('2d');
  var root = document.documentElement;
  root.classList.add('fa3-on');

  var mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;
  var RM = !!(mq && mq.matches);
  var FINE = window.matchMedia ? matchMedia('(hover: hover) and (pointer: fine)').matches : true;
  var PLANET = !document.querySelector('[data-fa3-planet="0"]');

  var W = innerWidth, H = innerHeight, D = 1;
  var A3BG = 0, A3COL = 0; // ES-08 fondo negro (0) · ES-10 plata (0): decisión de Sammis
  var mouse = { x: -1, y: -1, sx: -1, sy: -1, on: 0 };
  var OP = [], OR = [], OA = [], oyaw = 0, opitch = .35;
  var calm = 0, calmT = 0, ft = 0, lastT = 0, raf = 0;

  // ---------- Portada: el fondo parte después del video (héroe) ----------
  var hero = document.querySelector('.f-hero'), fade = 1;
  function heroFade() {
    if (!hero) return;
    var hb = hero.offsetHeight || 0; if (!hb) { fade = 1; cv.style.opacity = ''; return; }
    var p = (scrollY - hb * .18) / (hb * .55); p = p < 0 ? 0 : p > 1 ? 1 : p;
    if (p !== fade) { fade = p; cv.style.opacity = p.toFixed(3); }
  }

  // ---------- Planeta (ES-08, ES-10, ES-11, ES-12) ----------
  function rpt() { var u = Math.random() * 2 - 1, th = Math.random() * Math.PI * 2, r = Math.sqrt(1 - u * u); return [r * Math.cos(th), u, r * Math.sin(th)]; }
  function newArc(p0) { return { a: rpt(), b: rpt(), p: -(p0 || 0) * 1.4, v: .22 + Math.random() * .25, warm: Math.random() < .35 }; }
  function seed() {
    OP = []; OR = []; OA = [];
    if (!PLANET) return;
    var n = Math.round(Math.max(1600, Math.min(4200, W * H / 300))), ga = Math.PI * (3 - Math.sqrt(5));
    for (var i = 0; i < n; i++) { var y = 1 - (i / (n - 1)) * 2, r = Math.sqrt(1 - y * y), th = ga * i; OP.push([Math.cos(th) * r, y, Math.sin(th) * r, Math.random() < .06 ? 1 : 0]); }
    for (i = 0; i < 1100; i++) OR.push([1.35 + Math.random() * .45, Math.random() * Math.PI * 2, .05 + Math.random() * .08, Math.random()]);
    for (i = 0; i < 11; i++) OA.push(newArc(Math.random()));
  }
  function slerp(a, b, t) {
    var d = Math.max(-1, Math.min(1, a[0] * b[0] + a[1] * b[1] + a[2] * b[2])), om = Math.acos(d), so = Math.sin(om) || 1e-6;
    var k0 = Math.sin((1 - t) * om) / so, k1 = Math.sin(t * om) / so; return [a[0] * k0 + b[0] * k1, a[1] * k0 + b[1] * k1, a[2] * k0 + b[2] * k1];
  }
  function proj(v, cx, cy, R) {
    var cyw = Math.cos(oyaw), syw = Math.sin(oyaw), x = v[0] * cyw - v[2] * syw, z = v[0] * syw + v[2] * cyw, y = v[1];
    var cp = Math.cos(opitch), sp = Math.sin(opitch), y2 = y * cp - z * sp, z2 = y * sp + z * cp;
    var f = 3.4 / (3.4 - z2); return [cx + x * R * f, cy - y2 * R * f, z2];
  }
  function mix(a, b) { var k = A3COL / 100; return [0, 1, 2].map(function (i) { return Math.round(a[i] + (b[i] - a[i]) * k); }).join(','); }
  var EM = mix([176, 184, 196], [201, 168, 78]), CR = mix([226, 231, 238], [243, 223, 166]);
  var AR1 = mix([240, 243, 247], [243, 223, 166]) + ',', AR2 = mix([168, 177, 190], [201, 168, 78]) + ',';

  function draw(t, dt) {
    var lmx = mouse.sx, lmy = mouse.sy, lon = mouse.on && lmx >= 0 ? 1 : 0;
    var w = W, h = H, mob = w < 760, cx = w * .5, R = mob ? Math.max(w * .62, h * .3) : Math.max(w, h) * .34, cy = h * (mob ? .84 : .74) + R * .25;
    var tx = mouse.sx >= 0 ? (mouse.sx / w - .5) : 0, ty = mouse.sy >= 0 ? (mouse.sy / h - .5) : 0;
    oyaw += dt * .12; var keep = oyaw; oyaw = oyaw + tx * 1.4; opitch += ((.55 + ty * .4) - opitch) * .05;
    ctx.setTransform(D, 0, 0, D, 0, 0);
    var kb = A3BG / 100, bg = ctx.createRadialGradient(w * .5, h * .35, 0, w * .5, h * .35, Math.max(w, h) * .8);
    bg.addColorStop(0, 'rgb(' + Math.round(28 * kb) + ',' + Math.round(28 * kb) + ',' + Math.round(32 * kb) + ')');
    bg.addColorStop(1, 'rgb(' + Math.round(11 * kb) + ',' + Math.round(11 * kb) + ',' + Math.round(12 * kb) + ')');
    ctx.fillStyle = bg; ctx.fillRect(0, 0, w, h);
    if (!PLANET) { oyaw = keep; return; }
    var at = ctx.createRadialGradient(cx, cy, R * .8, cx, cy, R * 1.9); at.addColorStop(0, 'rgba(' + EM + ',.10)'); at.addColorStop(1, 'rgba(' + EM + ',0)'); ctx.fillStyle = at; ctx.fillRect(0, 0, w, h);
    var tilt = .42, ct = Math.cos(tilt), st = Math.sin(tilt);
    function ring(front) {
      for (var i = 0; i < OR.length; i++) {
        var q = OR[i], a = q[1] + t * q[2], r = q[0], v = [Math.cos(a) * r, 0, Math.sin(a) * r];
        var pr = proj([v[0], v[1] * ct - v[2] * st, v[1] * st + v[2] * ct], cx, cy, R);
        if ((pr[2] > 0) !== front) continue;
        ctx.fillStyle = q[3] < .15 ? 'rgba(' + EM + ',' + (.35 + pr[2] * .25) + ')' : 'rgba(' + CR + ',' + (.10 + (pr[2] + 1) * .12) + ')';
        ctx.fillRect(pr[0], pr[1], 1.3, 1.3);
      }
    }
    ring(false);
    for (var i = 0; i < OP.length; i++) {
      var q = OP[i], pr = proj(q, cx, cy, R), d = (pr[2] + 1) / 2;
      if (pr[2] < -0.05) { ctx.fillStyle = 'rgba(' + CR + ',' + (.05 + d * .08).toFixed(3) + ')'; ctx.fillRect(pr[0], pr[1], 1, 1); continue; }
      var lit = lon ? Math.exp(-((pr[0] - lmx) * (pr[0] - lmx) + (pr[1] - lmy) * (pr[1] - lmy)) / (2 * 170 * 170)) : 0;
      ctx.fillStyle = q[3] ? 'rgba(' + EM + ',' + Math.min(1, .5 + d * .5 + lit * .5).toFixed(3) + ')' : 'rgba(' + CR + ',' + Math.min(1, .18 + d * .62 + lit * .6).toFixed(3) + ')';
      var sz = .8 + d * 1.2 + lit * 1.4; ctx.fillRect(pr[0] - sz / 2, pr[1] - sz / 2, sz, sz);
    }
    OA.forEach(function (A, k) {
      A.p += A.v * dt;
      if (A.p > 1.45) { OA[k] = newArc(0); return; }
      var head = Math.min(1, A.p), tail = Math.max(0, A.p - .45); if (head <= 0) return;
      var N = 36, prev = null;
      for (var j = 0; j <= N; j++) {
        var u = tail + (head - tail) * j / N, v = slerp(A.a, A.b, u), lift = 1 + .28 * Math.sin(Math.PI * u);
        var p2 = proj([v[0] * lift, v[1] * lift, v[2] * lift], cx, cy, R);
        if (prev) {
          var al = (j / N) * (prev[2] > -0.1 || p2[2] > -0.1 ? .9 : .2);
          ctx.strokeStyle = 'rgba(' + (A.warm ? AR1 : AR2) + al.toFixed(3) + ')'; ctx.lineWidth = .6 + (j / N) * 1.4;
          ctx.beginPath(); ctx.moveTo(prev[0], prev[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
        }
        prev = p2;
      }
      if (A.p <= 1 && prev) { var hg = ctx.createRadialGradient(prev[0], prev[1], 0, prev[0], prev[1], 9); hg.addColorStop(0, 'rgba(255,240,220,.95)'); hg.addColorStop(1, 'rgba(' + EM + ',0)'); ctx.fillStyle = hg; ctx.fillRect(prev[0] - 9, prev[1] - 9, 18, 18); }
      if (A.p > 1 && A.p < 1.2) { var e = proj(A.b, cx, cy, R), rr = (A.p - 1) * 90; ctx.strokeStyle = 'rgba(' + EM + ',' + (1 - (A.p - 1) / .2) * .6 + ')'; ctx.lineWidth = 1; ctx.beginPath(); ctx.arc(e[0], e[1], rr, 0, Math.PI * 2); ctx.stroke(); }
    });
    ring(true);
    if (lon) { var lg = ctx.createRadialGradient(lmx, lmy, 0, lmx, lmy, 240); lg.addColorStop(0, 'rgba(' + CR + ',.06)'); lg.addColorStop(1, 'rgba(' + CR + ',0)'); ctx.fillStyle = lg; ctx.fillRect(0, 0, w, h); }
    oyaw = keep;
  }

  function size() {
    W = innerWidth; H = innerHeight; D = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(W * D); cv.height = Math.round(H * D);
    seed();
    heroFade();
    if (RM || document.hidden) draw(4, 0);
  }
  // ES-14 calma · ES-15 solo con la pestaña visible y sin movimiento reducido · portada: no se dibuja mientras está apagado
  function frame(now) {
    raf = 0;
    if (document.hidden || RM) return;
    var t = now / 1000, dt = lastT ? Math.min(.05, Math.max(0, t - lastT)) : 0; lastT = t;
    if (fade <= 0) { raf = requestAnimationFrame(frame); return; }
    mouse.sx += (mouse.x - mouse.sx) * .08; mouse.sy += (mouse.y - mouse.sy) * .08;
    calm += (calmT - calm) * .06; var fdt = dt * (1 - .82 * calm); ft += fdt;
    draw(ft + 4, fdt);
    raf = requestAnimationFrame(frame);
  }
  function start() { if (!raf && !RM && !document.hidden) { lastT = 0; raf = requestAnimationFrame(frame); } }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
  if (mq && mq.addEventListener) mq.addEventListener('change', function (e) { RM = e.matches; if (RM) draw(4, 0); else start(); });
  var rz = 0; addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(size, 120); });

  // ---------- Cajas A (ES-09, ES-16, ES-18) y secundario de vidrio (ES-05) ----------
  // Las listas vienen de src/build.py (las mismas que usa force-ds-site.css). Las filas del ranking y las tarjetas que se
  // dibujan por JS (galería, sedes) también calzan: todo va por delegación de eventos.
  var BOX = '.fa3-box, .f-pcard, .f-protocol-tile, .f-stack, .f-reel, .f-philo__cell, .libro-tier, .libro-pilar, .f-ciencia-card, .gal-region, .f-seq__cell, .fd-sede-card, .fl-band__card, .f-protocol-offer, .f-founder__wrap, .f-dbanner__card, .f-map__wrap, .fd-panel, .dsr-t27__in, .f-seq__ciencia-inner > div, .gal-gate-card, .f-product__media, .fl-card, .force-main .fa3-cart-box, .rkd-rankrow';
  var TILT = '.fa3-tilt, .f-pcard, .f-protocol-tile, .f-stack, .f-reel, .f-philo__cell, .libro-tier, .libro-pilar, .f-ciencia-card, .gal-region, .f-seq__cell, .fd-sede-card, .fl-band__card';
  var STILL = '.f-protocol-offer, .f-founder__wrap, .f-dbanner__card, .f-map__wrap, .fd-panel, .dsr-t27__in, .f-seq__ciencia-inner > div, .gal-gate-card, .f-product__media, .fl-card, .force-main .fa3-cart-box';
  var BTN2 = '.f-btn--secondary, .f-btn--gold-outline, .f-hero__cta-outline, .f-btn--ghost, .f-btn--white, .f-btn--line, .f-pcard__cta--add, .f-pcard .f-btn--primary, .gal-back, .gal-more, .fa3-btn2, .rkd-more';
  var lit = null, FIELD = 'input, textarea, select, [contenteditable]';
  function boxOf(el) { return el && el.closest ? el.closest(BOX) : null; }
  function is(c, s) { try { return c.matches(s); } catch (e) { return false; } }
  function rest(c) { c.classList.remove('near'); c.style.setProperty('--rx', '0deg'); c.style.setProperty('--ry', '0deg'); c.style.setProperty('--ty', '0px'); }
  function unlight() { if (lit) { lit.classList.remove('lit'); lit.style.setProperty('--hl', '0'); rest(lit); lit = null; } }
  function fix(c) { if (c && !c.classList.contains('fixed')) { c.classList.add('fixed'); rest(c); } }
  var btn = null;

  addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') {
      // ES-15: en el teléfono el paralaje y la luz solo mientras el dedo se mueve
      mouse.x = e.clientX; mouse.y = e.clientY; mouse.on = 1; if (mouse.sx < 0) { mouse.sx = mouse.x; mouse.sy = mouse.y; }
      return;
    }
    mouse.x = e.clientX; mouse.y = e.clientY; mouse.on = 1; if (mouse.sx < 0) { mouse.sx = mouse.x; mouse.sy = mouse.y; }
    if (RM) return;
    // la caja más interna bajo el cursor
    var c = boxOf(e.target);
    if (c !== lit) {
      unlight();
      if (c) {
        var b0 = c.getBoundingClientRect(), ang = Math.atan2(e.clientY - (b0.top + b0.height / 2), e.clientX - (b0.left + b0.width / 2)) * 180 / Math.PI + 90;
        c.style.setProperty('--a0', (ang - 330) + 'deg'); c.classList.add('lit'); lit = c;
      }
    }
    calmT = c ? 1 : 0;
    if (c) {
      var b = c.getBoundingClientRect(), x = e.clientX - b.left, y = e.clientY - b.top;
      c.style.setProperty('--mx', x + 'px'); c.style.setProperty('--my', y + 'px'); c.style.setProperty('--hl', '1');
      c.style.setProperty('--sx', ((e.clientX - (b.left + b.width / 2)) / W * 46).toFixed(1) + 'px');
      c.style.setProperty('--sy', ((e.clientY - (b.top + b.height / 2)) / H * 46).toFixed(1) + 'px');
      var still = c.classList.contains('fixed') || is(c, STILL);
      if (!still && is(c, TILT)) {
        c.classList.add('near');
        c.style.setProperty('--ry', ((x / b.width - .5) * 8).toFixed(2) + 'deg');
        c.style.setProperty('--rx', (-(y / b.height - .5) * 8).toFixed(2) + 'deg');
      }
      if (!still) c.style.setProperty('--ty', '-4px');
    }
    // luz dorada del borde del secundario de vidrio
    var bt = e.target.closest ? e.target.closest(BTN2) : null;
    if (btn && btn !== bt) btn.style.setProperty('--bh', '0');
    btn = bt;
    if (bt) { var r = bt.getBoundingClientRect(); bt.style.setProperty('--bx', (e.clientX - r.left) + 'px'); bt.style.setProperty('--by', (e.clientY - r.top) + 'px'); bt.style.setProperty('--bh', '1'); }
  }, { passive: true });
  document.addEventListener('pointerleave', function () { mouse.on = 0; unlight(); calmT = 0; if (btn) { btn.style.setProperty('--bh', '0'); btn = null; } });
  addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse') mouse.on = 0; }, { passive: true });
  addEventListener('scroll', function () { heroFade(); if (lit && FINE) { unlight(); calmT = 0; } }, { passive: true });

  // ES-18: caja con campos queda fija al tocarla o con el foco en un campo
  document.addEventListener('pointerdown', function (e) {
    var c = boxOf(e.target);
    document.querySelectorAll('.fixed').forEach(function (f) { if (f !== c && is(f, BOX) && !f.contains(document.activeElement)) f.classList.remove('fixed'); });
    if (c && c.querySelector(FIELD)) fix(c);
  }, { passive: true });
  document.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches(FIELD)) fix(boxOf(e.target)); });
  document.addEventListener('focusout', function (e) {
    var c = boxOf(e.target); if (!c) return;
    setTimeout(function () { if (!c.contains(document.activeElement)) c.classList.remove('fixed'); }, 0);
  });

  size();
  start();
})();
